import { render, staticRenderFns } from "./theme-update-logs.vue?vue&type=template&id=b91ba464&scoped=true&"
import script from "./theme-update-logs.vue?vue&type=script&lang=js&"
export * from "./theme-update-logs.vue?vue&type=script&lang=js&"
import style0 from "./theme-update-logs.vue?vue&type=style&index=0&id=b91ba464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ba464",
  null
  
)

export default component.exports